import { useContextState } from '../../../../../../hooks/theme'

const useStyles = () => {
  const { colors } = useContextState()

  return {

    container: {
        paddingTop: '30px',
        width: '100%',
        height: '100%'
      },
      subContainer: {
        marginTop: '20px',
        //marginLeft: '-5px',
        position: 'relative',
        paddingRight: '45px',
        paddingLeft: '3px',
        '& .downloadFiles': {
          marginBottom: '5px',
        },
      },
   
    tabsContainer: {
      //position: 'relative',
      paddingBottom: '20px'
    },
    setting: {
      display: 'flex',
      justifyContent: 'center',
      '& .MuiButton-root': {
        fontSize: '10px',
        color: colors.color4,
      },
      '& .setting': {
        color: 'white'
      }
    },
    TabList: {
      width: '100%',
      paddingRight: '50px',
      '& .MuiTabs-flexContainer': {
        paddingTop: '5px',
        columnGap: '10px',
        justifyContent: 'end',
        paddingRight: '2px',
      },
      '& .MuiTab-root': {
        borderTopLeftRadius: '0px',
        borderTopRightRadius: '0px',
        backgroundColor: `transparent`,
        color: colors.color10,
        '& .MuiTabs-scroller': {
          overflow: 'auto',
        },
        '&.Mui-selected': {
          backgroundColor: `${colors.color5}`,
          color: colors.primary,
          boxShadow: `0 0 4px ${colors.color10}`,
          fontWeight: '600'
        },
      },
      '& .MuiTabs-indicator': {
        backgroundColor: 'transparent',
      },
    },
    TabPanel: {
      '&.MuiTabPanel-root': {
        boxShadow: `0 0 4px ${colors.color13}`,
        borderRadius: '10px',
        width: '100%',
      },
    },
  }
}

export { useStyles }